var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pesquisa-mensagem"},[_c('div',{staticClass:"sucesso-pesquisa-titulo"},[_c('img',{attrs:{"src":_vm.urlIcone,"height":_vm.height,"width":_vm.width}})]),_c('div',{staticClass:"sucesso-pesquisa-titulo"},[_vm._v(" "+_vm._s(_vm.titulo)+" ")]),_c('div',{staticClass:"sucesso-pesquisa-texto"},[_vm._v(" "+_vm._s(_vm.descricao)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }